import { createRoot, hydrateRoot } from "react-dom/client";
import App from "./App";
import "./index.css";

const container = document.getElementById("root")!;

// Public pages are prerendered at build time (scripts/prerender.mjs); hydrate
// those so the server HTML is reused. Everything else starts from an empty shell.
if (container.hasChildNodes()) {
  hydrateRoot(container, <App />);
} else {
  createRoot(container).render(<App />);
}
